import { listBulletinShare } from "@rubi/api-generated";
import { useQuery } from "@tanstack/react-query";

export const PENDING_BULLETIN_SHARE_COUNT_KEY = [
  "bulletin-share",
  "pending",
  "count",
];

// Polls so a share arriving while the user is elsewhere in the portal still surfaces.
// react-query pauses the interval while the tab is hidden and refetches on focus.
export function usePendingBulletinShareCount(enabled: boolean) {
  return useQuery({
    queryKey: PENDING_BULLETIN_SHARE_COUNT_KEY,
    queryFn: async () => {
      // limit=0 returns only total_count, no share rows.
      const { data } = await listBulletinShare({
        query: { pending: true, limit: 0 },
        throwOnError: true,
      });
      return data.total_count ?? 0;
    },
    enabled,
    refetchInterval: 60_000,
  });
}
